import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#ffffff",
        },
        secondary: {
            main: "#FABB25",
        },
        background: {
            default: "#ffffff",
        },
    },
    typography: {
        allVariants: {
            fontFamily: "Cairo, sans-serif",
        },
    },
});

export default theme;
